import { ActionSheetController, ViewController, Content } from "ionic-angular";
import { Component, ViewChild } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { Store } from "@ngrx/store";

import { AppState } from "../../app/app.reducer";
import { Token, User } from "../../app/app.models";
import { AppUtilities } from "../../app/app.utilities";
import { GeneralPaginService } from "../../services/general.pagin.service";
import { ConfigService } from "../../services/config.service";

@Component({
  selector: "page-userdetail",
  templateUrl: "userdetail.html"
})
export class UserdetailPage {
  public tokens$: Token[] = [];
  public user$: User;
  moreAssets: boolean = false;
  public refresh;
  @ViewChild(Content)
  content: Content;

  constructor(
    public actionsheetCtrl: ActionSheetController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public store: Store<AppState>,
    private generalPaginService: GeneralPaginService,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private utilities: AppUtilities
  ) {
    this.user$ = navParams.data;
    var idiom = this.configService.getIdiom();
    if (idiom == "en") this.utilities.loading("Checking Blockchain");

    if (idiom == "es") this.utilities.loading("Consultando Blockchain");
    this.generalPaginService
      .getAssetsIdsOwnedBy(this.user$.address)
      .then((assets: any[]) => {
        this.utilities.loadingDismiss();
        if (assets) {
          if (assets.length > 0) {
            this.tokens$ = assets;
            this.moreAssets = this.generalPaginService.getMoreAssets();
          } else {
            this.moreAssets = false;
          }
        }
      });
  }

  openMenu() {
    let actionSheet = this.actionsheetCtrl.create({
      buttons: [
        {
          text: "Bloquear",
          role: "destructive",
          handler: () => {}
        },
        {
          text: "Reportar",
          handler: () => {}
        },
        {
          text: "Cancelar",
          role: "cancel"
        }
      ]
    });
    actionSheet.present();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad UserdetailsPage");
  }

  ionViewWillEnter() {}

  loadMoreAssets($event) {
    if (this.content.directionY == "down" && this.moreAssets) {
      console.log("Event ", $event);
      var idiom = this.configService.getIdiom();
      if (idiom == "en") this.utilities.loading("Checking Blockchain");

      if (idiom == "es") this.utilities.loading("Consultando Blockchain");
      setTimeout(() => {
        this.generalPaginService.getBlockAssets().then(assets => {
          if (assets.length > 0) {
            for (let asset of assets) {
              this.tokens$.push(asset);
            }
            this.moreAssets = this.generalPaginService.getMoreAssets();
          } else {
            this.moreAssets = this.generalPaginService.getMoreAssets();
          }
          this.utilities.loadingDismiss();
          $event.complete();
        });
      }, 1000);
    } else {
      $event.complete();
    }
  }

  doRefresh($event) {
    this.refresh = $event;
    this.generalPaginService
      .getAssetsIdsOwnedBy(this.user$.address)
      .then((assets: any[]) => {
        if (assets) {
          if (assets.length > 0) {
            this.tokens$ = assets;
            this.moreAssets = this.generalPaginService.getMoreAssets();
          } else {
            this.moreAssets = false;
          }
        }
        $event.complete();
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/userdetail/userdetail.ts